import { render, staticRenderFns } from "./ReviewBoosterContainer.vue?vue&type=template&id=99df2232&"
import script from "./ReviewBoosterContainer.vue?vue&type=script&lang=js&"
export * from "./ReviewBoosterContainer.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBoosterContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
